"use strict";
import imsrc from "../imsr-common.js";
import { ImsrApi } from "./imsrApi.js";

export class ImsrUsers {
  constructor() {
    this.imsrApi = new ImsrApi();
  }

  async getTenantUsers(tenantId) {
    try {
      let usersList = [];
      const params = {
        tenantId: tenantId
      };
      const res = await this.imsrApi.doApi("get", "/users/list", params);
      res.forEach(item => {
        usersList.push({
          userName: item.userName,
          userId: item.userId,
          userRole: item.userRole,
          created_at: imsrc.dateFormat(item.created_at),
          lastLogin: imsrc.dateFormat(item.lastLogin)
        });
      });
      return usersList;
    } catch (e) {
      throw { status: e.response.status, message: e.response.data.message };
    }
  }

  async getUser(tenantId) {
    try {
      const params = {
        tenantId: tenantId
      };
      const res = await this.imsrApi.doApi("get", "/users", params);
      // alert2_only_with_eventsがない場合はデフォルト値である毎回通知を設定する
      if (!("alert2_only_with_events" in res)) {
        res.alert2_only_with_events = "f";
      }
      return res;
    } catch (e) {
      throw { status: e.response.status, message: e.response.data.message };
    }
  }

  async checkMfa(tenantId) {
    try {
      const params = {
        tenantId: tenantId
      };
      const res = await this.imsrApi.doTokenApi("/users/checkMfa", params);
      return res;
    } catch (e) {
      throw { status: e.response.status, message: e.response.data.message };
    }
  }
  async getSoftToken(tenantId) {
    try {
      const params = {
        tenantId: tenantId
      };
      const res = await this.imsrApi.doTokenApi("/users/getSoftToken", params);
      return "data:image/png;base64," + res["image"];
    } catch (e) {
      throw { status: e.response.status, message: e.response.data.message };
    }
  }

  async verifyToken(tenantId, userCode) {
    try {
      const params = {
        tenantId: tenantId,
        userCode: userCode
      };
      await this.imsrApi.doTokenApi("/users/verifyToken", params);
      return true;
    } catch (e) {
      if (e.message == "fail.") {
        return false;
      }
      throw { status: e.response.status, message: e.response.data.message };
    }
  }

  async unsetMfa(tenantId) {
    try {
      const params = {
        tenantId: tenantId
      };
      await this.imsrApi.doTokenApi("/users/unsetMfa", params);
      return true;
    } catch (e) {
      if (e.message == "fail.") {
        return false;
      }
      throw { status: e.response.status, message: e.response.data.message };
    }
  }
}

export default ImsrUsers;
